import React, { useEffect, useState } from 'react';
import { addPaymentCard, deletePaymentCard, getPaymentCards } from '../../../../../../services/customer/profileServices';
import PaymentCard from './components/PaymentCard';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function PaymentCards() {
  const { trans } = useTranslation();
  const [paymentCards, setPaymentCards] = useState();

  const fetchData = async () => {
    const res = await getPaymentCards();
    setPaymentCards(res.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    await deletePaymentCard(id);
    fetchData();
  };

  const handleAddCard = async () => {
    const res = await addPaymentCard();
    window.location.replace(res.payment_url);
  };

  return (
    <div className="flex flex-col gap-4">
      <button
        type="button"
        className="text-primary bg-transparent border-none font-big-bold cursor-pointer text-base text-left"
        onClick={handleAddCard}
      >
        {trans('add')}
      </button>
      {paymentCards?.map((card) => (
        <PaymentCard
          key={card.id}
          data={card}
          handleDelete={handleDelete}
        />
      ))}
    </div>
  );
}

export default PaymentCards;
